import zIndex from '@mui/material/styles/zIndex';
import React from 'react';
import Swal from 'sweetalert2';

// Base Toast configuration
const ToastComponent = Swal.mixin({
  toast: true,
  showConfirmButton: false,
  timer: 3000,
  timerProgressBar: true,
});

export const Alert = (type = '', title = '', description = '') =>
  Swal.fire(title, description, type);

// This Toast is for pages WITH the sidebar
export const Toast = (type = '', title = '') =>
  ToastComponent.fire({
    icon: type,
    title,
    position: 'top',
    zIndex: 20000
  });

// This Toast is for pages WITHOUT the sidebar (e.g., AddToQuickTale)
export const CenteredToast = (type = '', title = '') =>
  ToastComponent.fire({
    icon: type,
    title,
    position: 'top',
    customClass: {
      container: 'swal2-container-centered',
    },
  });
